import { ICONS } from './navIcons';

export const endUserNavConfig = [
  {
    subheader: 'general',
    items: [{ title: 'Home', path: '/dashboard/two', icon: ICONS.dashboard }],
  },
];
